<template>
	<div class="view-content">
		<div class="page-heading">
			<h1>Velocity Reports</h1>
			<breadcrumb :model="breadcrumbs" />
		</div>
		<div class="tabs-wrapper">
			<div class="tabs">
				<div :class="['tab', { active: $route.name === 'DataLeadVelocityReport' }]">
					<router-link to="data"><div class="label">Data Leads</div></router-link>
				</div>
				<div :class="['tab', { active: $route.name === 'CallVelocityReport' }]">
					<router-link to="call"><div class="label">Calls</div></router-link>
				</div>
				<div :class="['tab', { active: $route.name === 'LiveTransferVelocityReport' }]">
					<router-link to="live-transfer"><div class="label">Live Transfers</div></router-link>
				</div>
				<div :class="['tab', { active: $route.name === 'CustomerVelocityReport' }]">
					<router-link to="customer"><div class="label">Customers</div></router-link>
				</div>
			</div>
			<div class="border"></div>
		</div>
		<div class="no-padding">
			<router-view />
		</div>
	</div>
</template>

<script>
export default {
	name: 'VelocityWrapper',
	components: {},
	data() {
		return {
			breadcrumbs: [
				{
					label: 'Velocity Report',
				},
			],
		};
	},
};
</script>

<style scoped lang="less">
.tabs-wrapper {
	margin: 0 -40px;
	position: relative;

	.border {
		border-bottom: 1px solid var(--gray-20);
		bottom: 0;
		position: absolute;
		width: 100%;
		z-index: 10;
	}
}

.tabs {
	display: flex;
	padding: 0 40px;
	position: relative;
	z-index: 20;

	.tab {
		background-color: var(--gray-10);
		border: 1px solid var(--gray-20);
		border-left: 0;
		cursor: default;
		font-size: 0.875rem;

		a {
			color: var(--gray-40);
			text-decoration: none;
		}

		.label {
			display: block;
			height: 3em;
			line-height: 3em;
			padding: 0 25px;
		}

		&:first-child {
			border-left: 1px solid var(--gray-20);
		}

		&:hover a {
			color: var(--gray-65);
		}

		&.active {
			border-bottom: 1px solid var(--gray-05);
			background-color: var(--gray-05);

			a {
				color: var(--gray-65);
			}

			.label {
				border-top: 3px solid var(--color-b);
				line-height: calc(3em - 6px);
			}
		}
	}
}

.no-padding {
	margin: 0 -40px;
}
</style>
